import "core-js/modules/es.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/yujian_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      form: {
        id: '',
        name: "",
        language: "",
        status: 1
      },
      disabled: false,
      rules: {
        name: [{
          required: true,
          message: "请输入类型名称",
          trigger: "blur"
        }],
        language: [{
          required: true,
          message: "请选择语言",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  computed: {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (data) {
                  _this.form = {
                    id: data.id,
                    name: data.name,
                    language: data.language,
                    status: data.status
                  };
                }

                _this.$refs.newPopover.open();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    clearData: function clearData(id) {
      this.form = {
        id: id,
        name: "",
        language: "",
        status: 1
      };
      this.$refs.ruleForm.resetFields();
    },
    submitData: function submitData() {
      var _this2 = this;

      this.$refs.ruleForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          var reqFn;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!valid) {
                    _context2.next = 5;
                    break;
                  }

                  reqFn = _this2.form.id ? 'updGameType' : 'addGameType';

                  _this2.$api[reqFn](_this2.form).then(function (res) {
                    if (res.code == 0) {
                      _this2.$message({
                        message: '操作成功',
                        type: 'success'
                      });

                      _this2.clearData();

                      _this2.$refs.newPopover.hide();

                      _this2.$emit('change');
                    }
                  });

                  _context2.next = 6;
                  break;

                case 5:
                  return _context2.abrupt("return", false);

                case 6:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};